
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    starRatingContainer: {
        fontFamily: 'initial'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/StarRating/styles.js